<template>
    <div class="content_container">
        <div class="container_left">
            <div class="title">
                <p>{{ sideNavObj.val }}</p>
                <p>{{ sideNavObj.englishVal }}</p>
            </div>
            <ul v-if="sideNavObj.children.length > 0">
                <li
                    v-for="(item, idx) in sideNavObj.children"
                    :key="idx"
                    :class="{ active: item.val === menuName }"
                    @click="tabChange(item.val)"
                >
                    {{ item.val }}
                </li>
            </ul>
        </div>
        <div class="container_right">
            <div class="title">
                <p class="text">{{ menuName }}</p>
                <div class="breadcrumb">
                    <i class="iconfont icon-shouye"></i>
                    <span>您当前所在位置：</span>
                    <span class="item" @click="goHome">首页</span>
                    <span class="item" @click="tabChange('办事指南')">
                        办事指南
                    </span>
                    <span class="item" v-if="menuName !== '办事指南'">{{
                        menuName
                    }}</span>
                </div>
            </div>
            <template v-if="list.length > 0">
                <ul class="list">
                    <li
                        v-for="item in list"
                        :key="item.id"
                        @click="goToDetail(item.id)"
                    >
                        <p class="item_title">
                            {{
                                menuName === '资料下载'
                                    ? item.fileName
                                    : item.mainTitle
                            }}
                        </p>
                        <p>
                            {{
                                moment(
                                    menuName === '资料下载'
                                        ? item.createTime
                                        : item.publishTime
                                ).format('YYYY-MM-DD')
                            }}
                        </p>
                    </li>
                </ul>
                <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page="current"
                    :total="total"
                ></el-pagination>
            </template>
            <div class="no_data" v-else>暂无数据</div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    components: {},
    data() {
        return {
            moment,
            menuName: '',
            sideNavObj: {
                val: '办事指南',
                englishVal: 'BUSINESS GUIDE',
                children: [
                    {
                        val: '制度法规',
                    },
                    {
                        val: '资料下载',
                    },
                    {
                        val: '人才招聘',
                    },
                    {
                        val: '联系我们',
                    },
                ],
            },
            // 分页
            current: 1,
            size: 10,
            total: 0,

            list: [],
        };
    },
    watch: {
        $route(val) {
            let menuName = val.query.current || '办事指南';
            this.tabChange(menuName);
        },
    },
    created() {
        let menuName = this.$route.query.current || '办事指南';
        this.tabChange(menuName);
    },
    methods: {
        goToDetail(id) {
            this.$router.push({
                path: '/guideDetail',
                query: {
                    id,
                    current: this.menuName,
                },
            });
        },
        // 改变当前页
        handleCurrentChange(val) {
            this.current = val;
            this.getList();
        },
        tabChange(menuName) {
            this.menuName = menuName;
            this.getList();
        },
        getList() {
            let { menuName, current, size } = this.$data;
            let data = { current, size, isPublish: '1' };
            let apiUrl = 'arcList';
            if (menuName === '资料下载') {
                apiUrl = 'fileList';
            } else {
                data['menuName'] = menuName;
            }
            this.$api[apiUrl](data).then((res) => {
                this.total = res.data.count;
                this.list = res.data.list;
            });
        },
        goHome() {
            this.$router.push('/home');
        },
    },
};
</script>

<style lang="scss" scoped>
.content_container {
    width: 1110px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    .container_left {
        width: 230px;
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        .title {
            height: 90px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #a13838;
            p {
                color: #fff;
                font-size: 12px;
                &:first-child {
                    margin-bottom: 5px;
                    font-size: 20px;
                }
            }
        }
        ul {
            flex: 1;
            border: 1px #efefef solid;
            li {
                padding: 15px 0;
                text-align: center;
                color: #666;
                border-bottom: 1px #efefef solid;
                position: relative;
                cursor: pointer;
                &:hover,
                &.active {
                    color: #a13838;
                    background-color: #fef4f4;
                }
                &.active {
                    &::before {
                        content: '';
                        width: 4px;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        background-color: #a13838;
                    }
                }
                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
    .container_right {
        flex: 1;
        display: flex;
        flex-direction: column;
        .title {
            height: 46px;
            padding: 0 20px;
            background-color: #fef4f4;
            font-size: 18px;
            color: #666;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text {
                display: flex;
                align-items: center;
                &::before {
                    content: '';
                    width: 4px;
                    height: 16px;
                    background-color: #a13838;
                    margin-right: 10px;
                }
            }
            .breadcrumb {
                font-size: 14px;
                .icon-shouye {
                    color: #a13838;
                    margin-right: 5px;
                }
                span {
                    color: #999;

                    &.item {
                        cursor: pointer;
                        &:hover {
                            color: #a13838;
                            &::after {
                                color: #999;
                            }
                        }
                        &::after {
                            content: ' > ';
                        }
                        &:last-child {
                            &::after {
                                display: none;
                            }
                            &:hover {
                                color: #999;
                                cursor: text;
                            }
                        }
                    }
                }
            }
        }
        .list {
            margin-top: 15px;
            flex: 1;
            li {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 15px 10px 15px 5px;
                position: relative;
                color: #666;
                cursor: pointer;
                border-bottom: 1px #e6e6e6 dashed;
                .item_title {
                    flex: 1;
                    padding: 0 20px 0 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 4px;
                        height: 4px;
                        border-radius: 4px;
                        background-color: #cecdcd;
                    }
                }
                &:hover {
                    color: #a13838;
                    .item_title {
                        &::before {
                            background-color: #a13838;
                        }
                    }
                }
            }
        }
        .pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            font-weight: normal;
        }
    }
}
</style>
